const initialState = {
  markupType: 'SP',
  currency: 'cad',
  cartVisible: false,
  preferencesModalOpen: false,
  exchangeRate: 1.3 // TODO
}

export default function settings (state = initialState, action) {
  switch (action.type) {
    case 'SET_DISPLAY_CART':
      return {
        ...state,
        cartVisible: action.value
      }
    case 'TOGGLE_DISPLAY_CART':
      return {
        ...state,
        cartVisible: !state.cartVisible
      }
    case 'SET_MARKUP_TYPE':
      return {
        ...state,
        markupType: action.value
      }
    case 'SET_CURRENCY':
      return {
        ...state,
        currency: action.value
      }
    case 'SET_EXCHANGE_RATE':
      return {
        ...state,
        exchangeRate: action.value
      }
    case 'OPEN_MODAL':
      return {
        ...state,
        preferencesModalOpen: action.value === 'preferences'
      }
    case 'CLOSE_MODAL':
      return {
        ...state,
        preferencesModalOpen: false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/settings.js